export default __webpack_public_path__ + "static/media/logo-text-color-rec-x.cb014796.svg";